import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useApproveQuality } from "../api/approve-quality";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { UpdateRetailOrderResult } from "../types/UpdateRetailOrderResult";

export default function ApproveQualityButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");
	const navigate = useNavigate();
	const location = useLocation();

	const approveQuality = useApproveQuality(
		order.details.retailOrderID,
		(result: UpdateRetailOrderResult) => {
			showSuccessMessage("Quality has been approved");

			const newActionRequiredID = result.activeARs.find(x => x == 145);
			const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
				(!!returnUrl ? '?returnUrl=' + returnUrl : '');

			if (newActionRequiredID && location.pathname !== to) {
				navigate(to);
			}
			else {
				refetchOrder();
			}
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-approve-quality' }}
				text="Approve Quality"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.InstallerToVerifyCabinetQuality)}
				disabled={approveQuality.isLoading}
				onClick={() => {
					if (!order.details.files.find(x => x.fileTypeID === FileTypes.CabinetQualityCheckWorksheet)) {
						showErrorMessage("Cabinet Quality Check Worksheet is required, please upload before approving");
					}
					else {
						approveQuality.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={approveQuality.isLoading}></LoadPagePanel>
		</>
	)
}
